var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIa5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 265,
    viewBox: "0 0 56 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2753 26.0544C54.1962 11.4956 42.3442 0.0273438 27.8824 0.0273438C13.4206 0.0273438 1.56862 11.4956 0.489524 26.0544H0.409424V234.271H0.489524C0.436446 234.986 0.409424 235.71 0.409424 236.439C0.409424 252.012 12.7095 264.635 27.8824 264.635C43.0553 264.635 55.3554 252.012 55.3554 236.439C55.3554 235.71 55.3283 234.986 55.2753 234.271H55.3554V26.0544H55.2753Z",
    fill: "#F39100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa5);
export default __webpack_public_path__ + "static/media/IA_5.aadc04d9eece90a3c40677f7a489676c.svg";
export { ForwardRef as ReactComponent };